import { render, staticRenderFns } from "./ProjectTextAnalysis.vue?vue&type=template&id=7fc66398&scoped=true&"
import script from "./ProjectTextAnalysis.vue?vue&type=script&lang=js&"
export * from "./ProjectTextAnalysis.vue?vue&type=script&lang=js&"
import style0 from "./ProjectTextAnalysis.vue?vue&type=style&index=0&id=7fc66398&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fc66398",
  null
  
)

export default component.exports